import { styled } from '@acko-tech/building-blocks.ui.common';

export const Page = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

export const Card = styled.form`
    width: 100%;
    max-width: 440px;
    background: #ffffff;
    border-radius: 12px;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
    display: flex;
    flex-direction: column;
    padding: 20px;
    margin-top: 5px;
`;

export const FormBody = styled.div`
    flex: 1;
    overflow-y: auto;
    overflow-x: visible;
`;

export const FieldWrapper = styled.div`
    position: relative;
    margin-bottom: 20px;
`;

export const Footer = styled.div`
    padding-top: 16px;
`;

export const SubmitButtonWrapper = styled.div`
    width: 100%;
`;

export const ModalText = styled.div`
    font-size: 16px;
    line-height: 24px;
    color: #040222;
    padding: 16px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
`;

export const ModalSubText = styled.span`
    color: #5b5675;
`;

export const PageHeading = styled.h1`
    font-size: 16px;
    color: #5b5675;
    font-weight: 600;
    margin-left: 5px;
`;
